import { Typography } from "@material-ui/core";
import * as React from "react";
import styled from "styled-components";
import { EmployeeAvatar } from "Components/Shared/EmployeeAvatar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { StyledFlex } from "Components/Shared/StyledComponents";
import { EmployeeDto, getUsersGetLoggedUserInfo } from "Api/Api";

type Props = {
  dropdownOpen: boolean;
  setDropdownOpen: (value: boolean) => void;
  displayDropdownIcon: boolean;
};

const StyledHeader = styled.div`
  padding: ${props => props.theme.spacing(3.5, 1.25, 2, 2)};

  h3 {
    font-weight: 400;
    color: ${props => props.theme.palette.text.primary};
  }

  p {
    color: ${props => props.theme.palette.text.secondary};
  }

  .avatar {
    margin-bottom: 8px;
  }

  .ibis-MuiSvgIcon-root {
    display: block;
  }
`;

const StyledIcon = styled.div<{ dropdownOpen?: boolean }>`
  cursor: pointer;
  svg {
    width: 20px;
    height: auto;
    max-height: 34px;

    ${props => props.dropdownOpen && `transform: rotate(180deg);`}
  }
`;

export const GuidepostLoggedUserInfo: React.FunctionComponent<Props> = props => {
  const { dropdownOpen, setDropdownOpen } = props;
  const [loggedUserInfo, setData] = React.useState<EmployeeDto>();

  React.useEffect(() => {
    getUsersGetLoggedUserInfo().then(result => {
      setData(result.json);
    });
  }, []);

  return (
    <>
      {loggedUserInfo && (
        <StyledHeader>
          <EmployeeAvatar
            firstName={loggedUserInfo.firstName}
            lastName={loggedUserInfo.lastName}
            imgUrl={loggedUserInfo.profilePhotoUrl}
          />
          <Typography variant={"h3"}>
            {`${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`}
          </Typography>
          <StyledFlex justifyContent={"space-between"} alignItems={"center"}>
            <Typography>{loggedUserInfo.positionName}</Typography>
            {props.displayDropdownIcon && (
              <StyledIcon
                onClick={() => setDropdownOpen(!dropdownOpen)}
                dropdownOpen={dropdownOpen}
              >
                <ExpandMoreIcon />
              </StyledIcon>
            )}
          </StyledFlex>
        </StyledHeader>
      )}
    </>
  );
};
